var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.15 0.00559618C16.0776 -0.00186539 16.0046 -0.00186539 15.9322 0.00559618H1.0572C0.961861 0.00706516 0.867157 0.0213601 0.775635 0.0480961L8.4522 7.69278L16.15 0.00559618Z",
    fill: "#646464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9363 0.744141L9.20125 8.44727C9.00218 8.64516 8.73288 8.75623 8.45219 8.75623C8.17149 8.75623 7.9022 8.64516 7.70312 8.44727L0.0371875 0.802578C0.0136209 0.889194 0.00112555 0.978446 0 1.0682V11.6932C0 11.975 0.111942 12.2452 0.311199 12.4445C0.510456 12.6438 0.780707 12.7557 1.0625 12.7557H15.9375C16.2193 12.7557 16.4895 12.6438 16.6888 12.4445C16.8881 12.2452 17 11.975 17 11.6932V1.0682C16.9958 0.95752 16.9743 0.848178 16.9363 0.744141ZM1.79031 11.6932H1.05188V10.9335L4.91406 7.1032L5.66313 7.85227L1.79031 11.6932ZM15.9269 11.6932H15.1831L11.3103 7.85227L12.0594 7.1032L15.9216 10.9335L15.9269 11.6932Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8f3c585c82f78aac6c39c8787f6f4768.svg";
export { ForwardRef as ReactComponent };